import {Provider} from '@angular/core';
import {OrderPlacingBaseService} from './order-placing-base.service';
import {OrderPlacingService} from './order-placing.service';

export const WIDGET_ORDER_PLACING_PROVIDERS: Provider[] = [
    OrderPlacingService,
    {
        provide:     OrderPlacingBaseService,
        useExisting: OrderPlacingService
    }
];
